var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1945_2162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 5.19615C42.5692 1.98076 49.4308 1.98076 55 5.19615L76.8372 17.8038C82.4064 21.0192 85.8372 26.9615 85.8372 33.3923V58.6077C85.8372 65.0385 82.4064 70.9808 76.8372 74.1962L55 86.8038C49.4308 90.0192 42.5692 90.0192 37 86.8038L15.1628 74.1962C9.59361 70.9808 6.16283 65.0385 6.16283 58.6077V33.3923C6.16283 26.9615 9.59361 21.0192 15.1628 17.8038L37 5.19615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5 60.2916H56.9166C55.25 60.2916 53.6667 60.9375 52.5 62.1042L48.9375 65.625C47.3125 67.2292 44.6666 67.2292 43.0416 65.625L39.4792 62.1042C38.3125 60.9375 36.7083 60.2916 35.0625 60.2916H33.5C30.0417 60.2916 27.25 57.5208 27.25 54.1042V31.375C27.25 27.9583 30.0417 25.1875 33.5 25.1875H58.5C61.9583 25.1875 64.75 27.9583 64.75 31.375V54.1042C64.75 57.5 61.9583 60.2916 58.5 60.2916Z",
    fill: "#CBE2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5833 52.1663C46.2708 52.2705 45.75 52.2705 45.4167 52.1663C42.7083 51.2288 36.625 47.3747 36.625 40.8122C36.625 37.9164 38.9583 35.583 41.8333 35.583C43.5417 35.583 45.0417 36.3955 46 37.6663C46.9583 36.3955 48.4583 35.583 50.1667 35.583C53.0417 35.583 55.375 37.9164 55.375 40.8122C55.3542 47.3747 49.2917 51.2288 46.5833 52.1663Z",
    fill: "#0071FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1945_2162",
    x: 0,
    y: 0,
    width: 92,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.579762 0 0 0 0 0.749505 0 0 0 0 1 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1945_2162"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard4);
export default __webpack_public_path__ + "static/media/card4.b946678bb87021c818076a68dfafe4fe.svg";
export { ForwardRef as ReactComponent };